/* TODO: t() */
let hitSlop = { top: 5, bottom: 5, left: 5, right: 5 };

let sizes = {
  headerHeight: 70,
  icons: {
    XS: 12,
    S: 16,
    M: 24,
    L: 28,
    XL: 64,
    XXL: 96,
  },
  navWidth: 230,
  resourcesNavWidth: 330,
};

let basicColors = {
  /** Same as Chakra's blue.500 */
  blue: '#3182ce',
  red: '#d00000',
  grey: '#D9E0E8',
  white: '#FFF',
  black: '#000',
  transparent: '#0000',
};

// TODO: Separate basic colors with theme colors
// E.g. dark grey is basic color,
// while border grey is theme color.
let themeColors = {
  /** Same as Chakra's blue.500 */
  blue: '#3182ce',
  red: '#d00000',
  withOpacity: {
    black40: '#0006',
    blue8: '#0091ea20',
    blue50: '#0091ea80',
  },
  backgroundBlue: '#d3e7f6',
  borderBlue: '#75bdef',
  headingText: '#444',
  listNameText: '#2B4A5C',
  listDetailText: '#577688',
  mainNavBackground: '#0A2841',
  mainNavSubRouteBackground: '#1d3d57',
  mainNavText: '#8D949C',
  grey: '#D9E0E8',
  /** Same as Chakra's gray.400 */
  headerGrey: '#a0aec0',
  /** Same as Chakra's gray.300 */
  borderGrey: '#cbd5e0',
  lightGrey: '#F7F8F9',
  mediumGrey: '#B3BFCB',
  backgroundGrey: '#EFF3F8',
  darkGrey: '#777D85',
  descGrey: '#0A2841',
  white: '#FFF',
  offWhite: '#f9f9f9',
  black: '#000',
  gold: '#fed701',
  transparent: '#0000',
  errorTextRed: '#A94442',
  errorBorderRed: '#D29698',
  errorBackgroundRed: '#EBCCD1',
  successTextGreen: '#3C763D',
  successBorderGreen: '#D6E9C6',
  successBackgroundGreen: '#DFF0D8',
  warningBorderRed: '#F9867A',
  warningBorderYellow: '#FFEB3B',
  footerBackgroundGrey: '#0A284108',
  marketNavBackground: '#17222E',
  browserDialogBackground: '#ffffcf',
  /** Same as Chakra's blue.500 */
  linkBlue: '#3182ce',
  greenButtonHovered: '#3B9C96',
  buttonHoveredBorder: '#307F7A',
  greyButtonText: '#C3CEDD',
  buttonGrey: '#6C7A8D',
  textInputBorder: '#D9E0EA',
  focusTextInputBorder: '#C3CCDAa',
  textInputBackground: '#DDE3EC',
  textInputText: '#8290A3',
  formTitle: '#4DB3A5',
  formButtonBackground: '#45B6AF',
  formButtonBorder: '#3EA49D',
  landingPageBackground: '#364150',
  copyright: '#7A8CA5',
  landingPageContainer: '#ECEEF1',
  greenToast: '#E0EFD8',
  orangeToast: '#FDF8E3',
  redToast: '#F2DEDF',
  greenToastText: '#406F43',
  orangeToastText: '#8C6F45',
  redToastText: '#A34543',
};

const BLACK_RGB_COLOR = {
  r: 0,
  g: 0,
  b: 0,
  a: 1,
};

const WHITE_RGB_COLOR = {
  r: 255,
  g: 255,
  b: 255,
  a: 1,
};

export {
  // Please sort this alphabetically.
  basicColors,
  BLACK_RGB_COLOR,
  WHITE_RGB_COLOR,
  hitSlop,
  sizes,
  themeColors,
};
